<div class="banner">
  <div class="collapse-arrow"></div>
  <div class="banner-label text-color vertical-center">Openstaande taken</div>
  <div class="count-label"></div>
</div>
<div class="list-container">
  <div *ngIf="loading" class="list-loader-overlay">
    <div class="overlay-spinner">
      <mat-spinner color="primary" diameter="75"></mat-spinner>
    </div>
  </div>

  <div class="banner uitgevoerd smaller-upper-space">
    <div class="collapse-arrow white-text">
      <div
        class="collapse-arrow-container"
        [ngClass]="baseProjects?.length > 0 ? 'clickable' : ''"
        (click)="baseProjectsCollapsed = !baseProjectsCollapsed"
      >
        <div class="collapse-arrow-icon">
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
      </div>
    </div>
    <div class="banner-label white-text vertical-center">Plaatsingstaken</div>
    <div class="count-label white-text vertical-center">
      Aantal:
      {{
        baseProjects != null && baseProjects.length > 0
          ? baseProjects.length
          : '0'
      }}
    </div>
  </div>
  <ng-container
    *ngTemplateOutlet="
      subProjectList;
      context: {
        subProjects: baseProjects,
        collapsed: baseProjectsCollapsed
      }
    "
  ></ng-container>

  <div class="banner aanpassing smaller-upper-space">
    <div class="collapse-arrow white-text">
      <div
        class="collapse-arrow-container"
        [ngClass]="adjustments?.length > 0 ? 'clickable' : ''"
        (click)="adjustmentsCollapsed = !adjustmentsCollapsed"
      >
        <div class="collapse-arrow-icon">
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
      </div>
    </div>
    <div class="banner-label white-text vertical-center">Aanpassingen</div>
    <div class="count-label white-text vertical-center">
      Aantal:
      {{
        adjustments != null && adjustments.length > 0 ? adjustments.length : '0'
      }}
    </div>
  </div>
  <ng-container
    *ngTemplateOutlet="
      subProjectList;
      context: {
        subProjects: adjustments,
        collapsed: adjustmentsCollapsed
      }
    "
  ></ng-container>

  <div class="banner verkocht-verhuurd smaller-upper-space">
    <div class="collapse-arrow white-text">
      <div
        class="collapse-arrow-container"
        [ngClass]="soldRenteds?.length > 0 ? 'clickable' : ''"
        (click)="soldRentedsCollapsed = !soldRentedsCollapsed"
      >
        <div class="collapse-arrow-icon">
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
      </div>
    </div>
    <div class="banner-label white-text vertical-center">Verkocht/Verhuurd</div>
    <div class="count-label white-text vertical-center">
      Aantal:
      {{
        soldRenteds != null && soldRenteds.length > 0 ? soldRenteds.length : '0'
      }}
    </div>
  </div>
  <ng-container
    *ngTemplateOutlet="
      subProjectList;
      context: {
        subProjects: soldRenteds,
        collapsed: soldRentedsCollapsed
      }
    "
  ></ng-container>

  <div class="banner weghalen smaller-upper-space">
    <div class="collapse-arrow white-text">
      <div
        class="collapse-arrow-container"
        [ngClass]="repos?.length > 0 ? 'clickable' : ''"
        (click)="reposCollapsed = !reposCollapsed"
      >
        <div class="collapse-arrow-icon">
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
      </div>
    </div>
    <div class="banner-label white-text vertical-center">Weghalen</div>
    <div class="count-label white-text vertical-center">
      Aantal: {{ repos != null && repos.length > 0 ? repos.length : '0' }}
    </div>
  </div>
  <ng-container
    *ngTemplateOutlet="
      subProjectList;
      context: {
        subProjects: repos,
        collapsed: reposCollapsed
      }
    "
  ></ng-container>
</div>
<ng-template
  #subProjectList
  let-subProjects="subProjects"
  let-collapsed="collapsed"
>
  <div
    class="sub-project-list"
    [collapse]="collapsed"
    [isAnimated]="!browserIsSafari"
  >
    <div
      *ngFor="let subProject of subProjects; trackBy: trackById"
      class="sub-project-entry"
    >
      <div class="flex-1">
        <div class="entry-value-container">#{{ subProject.project?.id }}</div>
      </div>
      <div class="flex-4">
        <ng-container *ngIf="subProject.project?.companyNames?.length > 0">
          <div class="entry-value-container">
            <div>
              <div *ngFor="let companyName of subProject.project.companyNames">
                {{ companyName }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex-1">
        <ng-container *ngIf="subProject.project?.products?.length > 0">
          <div class="entry-value-container">
            <div>
              <div *ngFor="let product of subProject.project.products">
                {{ product.boardPart?.kind | or: '' }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex-2">
        <ng-container *ngIf="subProject.project?.products?.length > 0">
          <div class="entry-value-container">
            <div>
              <div *ngFor="let product of subProject.project.products">
                {{ product.measurementsDisplay | or: '' }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex-4">
        <ng-container *ngIf="subProject.project?.products?.length > 0">
          <div class="entry-value-container">
            <div>
              <div *ngFor="let product of subProject.project.products">
                {{ product.typeDisplay | or: '' | shortenText: 50 }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex-4">
        <div class="entry-value-container">
          {{
            subProject.projectPlacement?.address?.line1
              | printAddress
                : subProject.projectPlacement?.address?.postalCode
                : subProject.projectPlacement?.address?.city
          }}
        </div>
      </div>
      <div class="flex-2">
        <div class="entry-value-container">
          <span
            *ngIf="
              subProject.currentRequestASAP &&
              subProject.currentRequestDate == null
            "
          >
            ASAP
          </span>
          <span *ngIf="subProject.currentRequestDate != null">
            {{ subProject.currentRequestDate | formatDate: '':'dd/MM/yyyy' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
